<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <div>
    <fui-heading [text]="'Communities'" [level]="5"></fui-heading>
    <small class="text-muted">
      Drag & drop to set the order members see them in.
      @if (savingOrder) {
        Saving…
      }
    </small>
  </div>
  <button class="btn btn-secondary" (click)="openDetail()">
    <fa-icon icon="plus"></fa-icon>
    Add
  </button>
</div>
<div class="row">
  <div class="col-md-12">
    @if (loading) {
      <myp-inline-loader [loading]="true" height="200px" spinnerName="loader"></myp-inline-loader>
    }
    @if (!loading && communities && !communities.length) {
      <span class="t-16 d-block m-t-30 gothic text-center">No communities yet.</span>
    }
    @if (communities && communities.length) {
      <div dragula="COMMUNITIES" [(dragulaModel)]="communities">
        @for (item of communities; track item.string_id) {
          <myp-list-item [title]="item.title" [photo]="photoById[item.string_id]" [imageRound]="false" [subData]="subDataById[item.string_id]" [item]="item" (itemClicked)="openDetail(item)">
            <div class="button-content">
              <!--
              Hidden-flag indicator. Only rendered when `item.hidden` is true (visible is
              the default state and gets no icon). Placed BEFORE the edit button so the
              status reads first when scanning the row.
            -->
              @if (item.hidden) {
                <fa-icon
                  icon="eye-slash"
                  placement="top"
                  [ngbTooltip]="'Hidden — filtered out of the public communities list. Direct link still works.'"
                  class="circle-icon-btn m-r-5 muted"
                  aria-label="Hidden community"
                ></fa-icon>
              }
              <button class="fa-button" (click)="openDetail(item, $event)">
                <fa-icon icon="edit" placement="top" [ngbTooltip]="'Edit'" class="action circle-icon-btn m-r-5"></fa-icon>
                <span class="sr-only">Edit Community</span>
              </button>
              <!--
              Delete intentionally omitted from the UI. Communities are cheap to recreate at
              the same string_id (posts + channels auto-reattach) but blowing one away in prod
              is destructive enough to keep gated behind Postman / scripts only. The paeapi
              DELETE /admin/communities/:id endpoint is still there for emergency ops.
            --></div>
          </myp-list-item>
        }
      </div>
    }
  </div>
</div>
